import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import { useInstance, onBeforeUnmount, onUpdated } from 'intact-vue';
import { addOrRemove } from './useChecked';
export function useResetRowStatus(getAllKeys) {
  var instance = useInstance();
  var allUnmountedRows = [];
  var willUnmounted = false;
  function onRowBeforeUnmount(key) {
    if (willUnmounted || instance.get('keepStatus')) return;
    // maybe the row is only removed by shrinking, i.e. tree table
    var allKeys = getAllKeys();
    if (_includesInstanceProperty(allKeys).call(allKeys, key)) return;
    allUnmountedRows.push(key);
  }
  function reset() {
    if (allUnmountedRows.length) {
      omit('checkedKeys', allUnmountedRows);
      omit('selectedKeys', allUnmountedRows);
      omit('spreadKeys', allUnmountedRows);
      omit('expandedKeys', allUnmountedRows);
      allUnmountedRows = [];
    }
  }
  function omit(type, keys) {
    var originKeys = instance.get(type);
    if (!originKeys) return;
    originKeys = _sliceInstanceProperty(originKeys).call(originKeys);
    keys.forEach(function (key) {
      return addOrRemove(originKeys, key, false);
    });
    instance.set(type, originKeys);
  }
  onBeforeUnmount(function () {
    return willUnmounted = true;
  });
  onUpdated(reset);
  return {
    onRowBeforeUnmount: onRowBeforeUnmount
  };
}